// 9fbef606107a605d69c0edbcd8029e5d
import { compose } from 'redux';
import { connect } from 'react-redux';
import { getIsAddCouponHomepageEnabled } from '@tcp/core/src/reduxStore/selectors/session.selectors';

import ModuleSlider from '../views/ModuleSlider';
import { readCookie } from '../../../../../utils';

export const mapStateToProps = (state) => {
  return {
    isAddCouponHomepageEnabled: getIsAddCouponHomepageEnabled(state),
    cartItemsValue: readCookie('cartItemsCount'),
  };
};

const withConnect = connect(mapStateToProps);

export default compose(withConnect)(ModuleSlider);
